import {
    getData,
    postData,
    patchData,
    deleteData
} from './Services'

export const getAccionesEmpleadosPanel = async (searchSel) => {
    let queryParams = [];
    if (searchSel) {
        queryParams.push(`sel_id=${encodeURIComponent(searchSel || '')}`);
    }
    const queryString = queryParams.length > 0 ? `?&${queryParams.join('&')}` : '';

    return await getData("/useracciones", queryString);
};

export const postAccionEmpleado = async (body) => {
    const res = await postData('/useracciones', body)
    return res
}

export const patchAccionEmpleado = async (id, body) => {
    const res = await patchData(`/useracciones/${id}`, body)
    return res
}

export const deleteAccionEmpleado = async (id) => {
    const res = await deleteData(`/usuariosacciones/${id}`)
    return res
}